export const POSTHOG_FEATURES = {
  REVENUE_DEP_VAR_SETUP_PAGE: "revenue-dep-var-setup-page",
  // AMAZON_REVENUE_SOURCE: "amazon-dep-var", Removed
  ONBOARDING_CONNECTION_FLOW_ENABLED: "connection-flow",
  // BRAND_MEDIA_MENTIONS: "brand-media-mentions", Removed
  // GA_MULTI_PROPERTY: "ga-multi-property", Removed
  // AMAZON_SCALER_TOGGLE: "amazon-scaler-toggle", Removed
  // HOMEPAGE_ENABLED: "homepage-enabled", Removed
  // HOMEPAGE_V2: "homepage-v2", Removed
  // CREATIVE_REPORTS_PAGE: "creative-reports-page", Removed
  // CREATIVE_REPORTS_V2: "creative-reports-v2", Removed
  IG_TAG_REVIEW: "ig-tag-review",
  // HOW_AI_SEES_YOUR_BRAND: "how-ai-sees-your-brand", Removed
  SYSTEM_NOTIFICATION_BY_COMPANY: "system-notification-by-company",
  SYSTEM_BANNER: "system-banner",
  PAID_MEDIA_WEIGHTS: "paid-media-weights",
  // REVENUE_KPI: "revenue-kpi", Removed
  // REVENUE_FROM_SEARCH: "revenue-from-search", Removed
  BUDGET_MANAGEMENT: "budget-management",
  AD_FORGE_ENABLED: "ad-blaster-enabled",
  EXPERIMENTS: "experiments",
  // GOOGLE_CONNECTOR: "google-analytics-connector", Removed
  USE_MEDIA_TAGS: "media-tags",
  USE_STRUCTURED_TAGS: "structured-tags",
  WEB_ANALYTICS: "web-analytics",
  AD_FORGE: "ad-forge",
  ASSET_MANAGER: "asset-manager",
  METRIC_DICTIONARY: "metric-dictionary",
  CHATBOT: "chatbot",
  MARKET_PREDICTION: "market-prediction",
  GOOGLE_DRIVE: "google-drive",
  CREATIVE_MANAGEMENT: "creative-management",
  LTV_COHORTS: "ltv-cohorts",
  SUBSEQUENT_PURCHASES: "subsequent-purchases",
  PARTNERSHIP_TRACKER_ENABLED: "partnership-tracker-enabled",
  // Ad comment moderation (MD-5576): nav entry + route, rolled out per brand.
  COMMENT_MODERATION: "comment-moderation",
  // Standalone Meta campaign budget editor (live Marketing API, no Cube):
  // used for the Meta App Review screencast of ads_management.
  META_BUDGET_EDITOR: "meta-budget-editor",
}

export type TPosthogFeatureKey =
  (typeof POSTHOG_FEATURES)[keyof typeof POSTHOG_FEATURES]
